<template>
  <transition name="fade-in-out">
    <div class="tip" v-show="visible && showTips" :style="position">
      <div id="empty"></div>
      <img src="../../assets/little-fatty.png" border="0" />
      <P>
        {{text}}
      </p>
      <span class="close-tips" @click="showQuickManu">关闭新手提示</span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      showTips: true,
      text: '气泡提示',
      position: '',
    }
  },
  mounted() {
    this.$bus.on('switchTips', (data) => {
      this.showTips = data;
    });
    this.$bus.on('showTips', (data) => {
      if (window.localStorage.getItem('showTips') && window.localStorage.getItem('showTips') === 'hide') {
        return;
      } else {
        this.visible = true;
        this.text = data.text;
        this.position = data.position;
      }
    });
    // 点击其他地方后关闭气泡提示
    document.addEventListener('mousedown', (e)=> {
      if (e.target.className != 'tip' && e.target.className != 'close-tips') {
        this.visible = false;
      }
    });
  },
  methods: {
    showQuickManu() {
      this.$bus.emit('Modal_vue', {name : 'quickManu'});
      this.$bus.emit('quickManu-popover');
      this.visible = false;
    }
  }
}
</script>

<style lang="scss">
.tip {
  position: absolute;
  // top: 200px;
  // left: 900px;
  width: 277px;
	height: 154px;
  font-size: 14px;
  color: #fffffe;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 10px;
  z-index: 1000;
  _zoom: 1;
  #empty {
    float: right;
    width: 1px;
    height: 51px;
  }
  p {
    text-align: left;
    line-height: 1.4;
    margin: 20px 30px 20px 23px;
  }
  img {
    float: right;
    clear: right;
    width: 77px;
    height: 108px;
    margin-right: -8px;
  }
  .close-tips {
    position: absolute;
    bottom: 9px;
    left: 23px;     
    text-decoration: underline;
    cursor: pointer;
  }
}
.slide-top-enter-active {
  transition: all .3s linear;
}
.slide-top-leave-active {
  transition: all .3s linear;
}
.slide-top-enter, .slide-top-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
.slide-top-enter-to, .slide-top-leave {
  transform: translateY(0);
  opacity: 1;
}

.fade-in-out-enter-active {
  transition: all 1s ease;
}
.fade-in-out-leave-active {
  transition: all .5s ease;
}
.fade-in-out-enter, .fade-in-out-leave-to {
  opacity: 0;
}
.fade-in-out-enter-to, .fade-in-out-leave {
  opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/guidance/tip.vue